import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { AuthLayout } from './Login';

const REDIRECT_URL = `${window.location.origin}/auth/callback`;

export default function Signup() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    setError(null);
    const { error: err } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: REDIRECT_URL,
        shouldCreateUser: true,
        data: { full_name: name },
      },
    });
    if (err) {
      setStatus('error');
      setError(err.message);
      return;
    }
    setStatus('sent');
  };

  return (
    <AuthLayout title="Đăng ký dạy" subtitle="Tạo tài khoản giáo viên miễn phí">
      {status === 'sent' ? (
        <div className="text-center text-sm text-gray-600">
          <p className="text-3xl mb-2">📬</p>
          <p>Chúng tôi đã gửi liên kết xác nhận tới:</p>
          <p className="font-semibold text-gray-900 mt-1">{email}</p>
          <p className="mt-3 text-xs text-gray-400">
            Bấm vào liên kết trong email để hoàn tất đăng ký.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="Họ và tên"
            className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:border-red-400 focus:ring focus:ring-red-100 outline-none"
          />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="email@example.com"
            className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:border-red-400 focus:ring focus:ring-red-100 outline-none"
          />
          {error && <p className="text-sm text-rose-700">{error}</p>}
          <button
            type="submit"
            disabled={status === 'sending'}
            className="w-full bg-red-700 text-white font-medium py-2 rounded-lg hover:bg-red-800 disabled:opacity-50 transition-colors"
          >
            {status === 'sending' ? 'Đang gửi…' : 'Tạo tài khoản'}
          </button>
          <p className="text-xs text-gray-500 text-center">
            Đã có tài khoản?{' '}
            <Link to="/login" className="text-red-700 font-medium hover:underline">
              Đăng nhập
            </Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
